module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-hakone-1-4359f46a1111137c5c396934b10447d5.webp";